'use server';

import { SessionService } from '@/contexts/authentication';
import type { ContentCreationPlan } from '@/contexts/content/types/contentPlan';
import { ContentCreationPlanService } from '@/contexts/content/services/ContentCreationPlanService';

export async function getContentPlan(
  planId: string,
): Promise<ContentCreationPlan | null> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return null;

  const service = new ContentCreationPlanService();
  return service.getPlan(planId, familyId);
}
